import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    VSwitch: {
      inset: true,
    },
    VListItem: {
      slim: true,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#884aff', // Soft purple - warm and inviting
          secondary: '#F0A868', // Warm orange - cozy accent
          accent: '#64CCC5', // Soft teal - calming
          error: '#EF6C6C', // Softer red
          info: '#6FA3EB', // Soft blue
          success: '#81C784', // Soft green
          warning: '#FFB74D', // Warm amber
          background: '#FFFFFF', // Very light gray
          surface: '#FFFFFF', // Pure white
          'on-background': '#2E3440',
          'on-surface': '#2E3440',
        },
      },
      dark: {
        colors: {
          primary: '#9D88F3', // Lighter purple for dark mode
          secondary: '#FFB885', // Lighter warm orange
          accent: '#7DDDD6', // Lighter teal
          error: '#FF8A8A', // Softer red for dark
          info: '#90C3FF', // Softer blue for dark
          success: '#A1D9A4', // Softer green for dark
          warning: '#FFD082', // Softer amber for dark
          background: '#1A1F2E', // Deep blue-gray
          surface: '#242938', // Slightly lighter than background
          'on-background': '#E5E9F0',
          'on-surface': '#E5E9F0',
        },
      },
    },
  },
})
